import PrescriptionType from "../enums/prescriptionType.enum.js";

export const PrescriptionData = [
  {
    types: [PrescriptionType.EZETIMIBE_10MG],
    howToUse: [
        "Dosage: Take ezetimibe exactly as prescribed by your healthcare provider. The typical dose is 10 mg once daily.",
        "Administration: Ezetimibe can be taken with or without food. Swallow the tablet whole with water.",
        "Missed Dose: If you miss a dose, take it as soon as you remember. If it’s almost time for your next dose, skip the missed dose and resume your regular schedule. Do not double the dose to catch up."
    ],
    sideEffects: [
        "Common Side Effects: Upper respiratory tract infections, Diarrhea, Joint pain, Fatigue",
        "Serious Side Effects: Muscle problems (e.g., myopathy, rhabdomyolysis), Liver damage (e.g., hepatitis), Severe allergic reactions (e.g., angioedema)",
    ],
    interactions:[
        "Cyclosporine: Concurrent use can increase ezetimibe levels, raising the risk of side effects.",
        "Fibrates (e.g., gemfibrozil): Using these with ezetimibe may increase the risk of gallstones and muscle problems.",
        "Warfarin: Ezetimibe may enhance the effect of warfarin, increasing bleeding risk. Monitor INR levels closely.",
        "Bile Acid Sequestrants: These can interfere with ezetimibe absorption. Take ezetimibe at least 2 hours before or 4 hours after these medications.",
    ],
    precautions: [
        "Medical History: Inform your doctor if you have liver disease, kidney problems, or a history of muscle disorders.",
        "Pregnancy and Breastfeeding: Consult your healthcare provider before using ezetimibe if you are pregnant, planning to become pregnant, or breastfeeding.",
        "Alcohol Consumption: Limit alcohol intake, as it can increase the risk of liver damage while taking ezetimibe.",
    ],
    overDose: [
        "Symptoms: Overdose may lead to increased risk of side effects such as diarrhea and fatigue.",
        "Action: If overdose is suspected, seek immediate medical attention or contact a poison control center.",
    ],
    storage: [
        "Temperature: Store at room temperature between 20°C to 25°C (68°F to 77°F).",
        "Protection: Keep the medication in its original packaging, away from moisture and light.",
        "Safety: Keep out of reach of children and pets.",
    ]
  },
  {
    types: [PrescriptionType.ROSUVASTATIN_2500MCG, PrescriptionType.ROSUVASTATIN_5MG, PrescriptionType.ROSUVASTATIN_10MG, PrescriptionType.ROSUVASTATIN_20MG],
    warnings: [
        "Breastfeeding is not recommended while using this drug. Consult your doctor or pharmacist.",
        "If you are pregnant or considering becoming pregnant you should discuss the use of this medication with your doctor or pharmacist.",
        "Do not take aluminum or magnesium antacids within 2 hours of taking this medication."
    ],
    howToUse: [ 
        "Dosage: Take rosuvastatin exactly as prescribed by your healthcare provider. The typical starting dose ranges from 5 to 10 mg once daily, with adjustments based on individual response and risk factors.",
        "Administration: Rosuvastatin can be taken with or without food, at any time of day. Swallow the tablet whole with water.",
        "Missed Dose: If you miss a dose, take it as soon as you remember. If it’s almost time for your next dose, skip the missed dose—do not double up."
    ],
    sideEffects: [
        "Common Side Effects: Headache, Muscle aches or weakness, Abdominal pain, Nausea, Dizziness",
        "Serious Side Effects: Severe muscle problems (e.g., rhabdomyolysis), Liver damage (e.g., jaundice, dark urine), Allergic reactions (e.g., rash, itching, swelling)"
    ],
    interactions: [
        "Antacids: Taking antacids containing aluminum or magnesium can reduce rosuvastatin absorption. Take rosuvastatin at least 2 hours before or after such antacids.",
        "Cyclosporine: Concurrent use increases rosuvastatin levels, raising the risk of side effects.",
        "Fibrates and Niacin: Using these with rosuvastatin may increase the risk of muscle problems.",
        "Warfarin: Rosuvastatin can enhance the effect of warfarin, increasing bleeding risk. Monitor INR levels closely."
    ],
    precautions: [
        "Medical History: Inform your doctor if you have liver disease, kidney problems, thyroid disorders, or a history of alcohol use.",
        "Pregnancy and Breastfeeding: Do not use rosuvastatin if you are pregnant or breastfeeding.",
        "Alcohol Consumption: Limit alcohol intake, as it can increase the risk of liver damage while taking rosuvastatin."
    ],
    overDose: [
        "Symptoms: Overdose may lead to severe muscle pain, weakness, and liver issues.",
        "Action: If overdose is suspected, seek immediate medical attention or contact a poison control center."
    ],
    storage: [
        "Temperature: Store at room temperature between 20°C to 25°C (68°F to 77°F).",
        "Protection: Keep the medication in its original packaging, away from moisture and light.",
        "Safety: Keep out of reach of children and pets."
    ]
  },
  {
    types: [PrescriptionType.ICOSAPENT_ETHYL_1G, PrescriptionType.ICOSAPENT_ETHYL_2G, PrescriptionType.ICOSAPENT_ETHYL_4G],
    warnings: [
        "Take with food.",
        "Do not chew or crush before swallowing.",
    ],
    howToUse: [
        "Dosage: Follow your doctor’s instructions. Typically, the recommended dose is 4 grams per day, taken as either two 1-gram capsules twice daily or four 0.5-gram capsules twice daily.",
        "Administration: Take with food. Swallow capsules whole; do not crush, chew, or dissolve them.",
        "Missed Dose: If you miss a dose, take it as soon as you remember. If it’s almost time for your next dose, skip the missed dose and resume your regular schedule. Do not double the dose to catch up."
    ],
    sideEffects: [
        "Common Side Effects: Joint or muscle pain, Constipation, Swelling of the hands, legs, or feet, Gout, Abnormal heart rhythms (e.g., atrial fibrillation)",
        "Serious Side Effects: Severe allergic reactions (e.g., rash, itching/swelling, severe dizziness, difficulty breathing), Bleeding complications, especially if taken with other blood-thinning medications"
    ],
    interactions: [
        "Anticoagulants and Antiplatelet Drugs: Concurrent use may increase the risk of bleeding.",
        "Other Medications: Always inform your healthcare provider about all the medications and supplements you’re taking to assess potential interactions."
    ],
    precautions: [
        "Fish Allergy: Icosapent ethyl is derived from fish oil. Patients with known hypersensitivity to fish or shellfish should use caution.",
        "Medical Conditions: Discuss with your doctor if you have a history of atrial fibrillation, bleeding disorders, or liver problems.",
        "Pregnancy and Breastfeeding: Consult your healthcare provider before using this medication if you are pregnant, planning to become pregnant, or breastfeeding."
    ],
    overDose: [
        "Symptoms: Overdose may lead to increased risk of side effects such as bleeding.",
        "Atrial Fibrillation/Flutter: Icosapent ethyl has been associated with an increased risk of atrial fibrillation or atrial flutter requiring hospitalization, particularly in patients with a history of these conditions.",
        "Bleeding Risk: There may be an increased risk of bleeding, especially in patients taking anticoagulants or antiplatelet medications.",
        "Action: In case of overdose, seek immediate medical attention or contact a poison control center at 1-800-222-1222."
    ],
    storage: [
        "Temperature: Store at room temperature between 20°C to 25°C (68°F to 77°F). Short-term storage between 15°C to 30°C (59°F to 86°F) is permissible.",
        "Safety: Keep out of reach of children. Do not use after the expiration date."
    ]
  },
  {
    types: [
        PrescriptionType.METFORMIN_500MG, 
        PrescriptionType.METFORMIN_850MG, 
        PrescriptionType.METFORMIN_1000MG,  
        PrescriptionType.METFORMIN_ER_500MG, 
        PrescriptionType.METFORMIN_ER_750MG, 
        PrescriptionType.METFORMIN_ER_1500MG],
        
    warnings: [
      "Take with meals to reduce stomach upset.",
      "Surgical Procedures and Imaging: Temporarily discontinue metformin before any surgical or radiologic procedures involving iodinated contrast agents, as these can affect kidney function."
     
    ],
    howToUse: [
        "Dosage: Follow your doctor’s instructions. Typically, metformin is started at a low dose (e.g., 500 mg once or twice daily) and gradually increased to minimize gastrointestinal side effects.",
        "Administration: Take metformin with meals to reduce stomach upset. Swallow tablets whole; do not crush or chew extended-release tablets.",
        "Missed Dose: If you miss a dose, take it as soon as you remember. If it’s near the time of your next dose, skip the missed dose. Do not double the dose to catch up."
    ],
    sideEffects: [
        "Common: Nausea, Diarrhea, Vomiting, Abdominal pain, Indigestion, Injection site reactions (redness, swelling).",
        "Serious: Lactic acidosis (see Warnings), Vitamin B12 deficiency with long-term use, which may lead to anemia and neuropathy, Hypoglycemia (low blood sugar), especially when combined with other diabetes medications."
    ],
    interactions: [
        "Alcohol: Increases the risk of lactic acidosis.",
        "Iodinated Contrast Agents: Can affect kidney function; metformin should be temporarily discontinued before procedures involving these agents.",
        "Cimetidine: May increase metformin levels in the blood, raising the risk of side effects.",
        "Other Medications: Inform your doctor about all medications you’re taking, including over-the-counter drugs and supplements, to avoid potential interactions."
    ],
    precautions: [
        "Medical History: Inform your doctor if you have a history of kidney or liver disease, heart problems, or alcohol abuse.",
        "Pregnancy and Breastfeeding: Discuss with your doctor the risks and benefits of using metformin during pregnancy or while breastfeeding.",
        "Surgical Procedures: Inform your healthcare provider that you’re taking metformin before any surgery or medical procedure.",
        "Lactic Acidosis: Metformin can rarely cause a serious (sometimes fatal) condition called lactic acidosis. Seek immediate medical attention if you experience symptoms such as unusual tiredness, dizziness, severe drowsiness, chills, blue/cold skin, muscle pain, fast/difficult breathing, slow/irregular heartbeat, or stomach pain with nausea, vomiting, or diarrhea.",
        "Kidney Function: Metformin is contraindicated in patients with severe renal impairment (eGFR below 30 mL/min/1.73 m²). Kidney function should be assessed before initiating treatment and periodically thereafter.",
        "Alcohol Consumption: Excessive alcohol intake increases the risk of lactic acidosis. Limit alcohol while taking this medication.",
  
    ],
    overDose: [
        "Symptoms: Overdose may lead to lactic acidosis, characterized by symptoms such as severe weakness, slow heart rate, trouble breathing, and stomach discomfort.",
        "Action: If overdose is suspected, seek immediate medical attention or contact a poison control center."
    ],
    storage: [
        "Temperature: Store at room temperature, away from moisture and heat.",
        "Safety: Keep out of reach of children and pets.",
        "Disposal: Do not flush medications down the toilet or pour them into a drain unless instructed to do so. Properly discard this product when it is expired or no longer needed. Consult your pharmacist or local waste disposal company."
    ]
  },
  {
    types: [PrescriptionType.ZEPBOUND_VIAL_2500MCG, PrescriptionType.ZEPBOUND_VIAL_5000MCG],
    howToUse: [
        "Preparation: Wash your hands thoroughly. Inspect the vial; the solution should be clear and colorless to slightly yellow. Do not use if it appears cloudy, discolored, or contains particles.",
        "Injection: Use a new syringe and needle for each injection. Draw the prescribed dose into the syringe. Inject subcutaneously into the abdomen, thigh, or upper arm. Rotate injection sites with each dose to reduce the risk of lipodystrophy.",
        "Missed Dose: If you miss a dose, take it as soon as possible within 4 days (96 hours). If more than 4 days have passed, skip the missed dose and resume your regular schedule."
    ],
    sideEffects: [
        "Common: Nausea, diarrhea, vomiting, abdominal pain, indigestion, injection site reactions (redness, swelling).",
        "Serious: Pancreatitis, gallbladder problems, kidney issues, severe allergic reactions, thyroid tumors."
    ],
    interactions: [
        `Insulin and Sulfonylureas: May increase the risk of hypoglycemia. Monitor blood sugar levels closely.`,
        `Oral Contraceptives: Zepbound may reduce the effectiveness of oral contraceptives. Consider alternative contraceptive methods during treatment.`
    ],
    precautions: [
        "Medical History: Inform your doctor if you have a history of pancreatitis, gallbladder disease, kidney problems, or thyroid tumors.",
        "Pregnancy: Zepbound may harm an unborn baby. Discuss potential risks with your healthcare provider.",
        "Breastfeeding: It is unknown if Zepbound passes into breast milk. Consult your doctor before breastfeeding."
    ],
    overDose: [
        "Symptoms: Overdose may cause severe nausea, vomiting, or hypoglycemia.",
        "Action: If overdose is suspected, seek immediate medical attention or contact a poison control center."
    ],
    storage: [
        "Refrigeration: Store in the refrigerator between 36°F and 46°F (2°C to 8°C).",
        "Room Temperature: If needed, vials can be kept at room temperature (up to 86°F or 30°C) for up to 21 days.",
        "Disposal: Do not use past the expiration date. Dispose of unused medication properly"
    ]
  },
  {
    types: [PrescriptionType.ZEPBOUND_AUTOINJECTOR_2500MCG, PrescriptionType.ZEPBOUND_AUTOINJECTOR_5000MCG, PrescriptionType.ZEPBOUND_AUTOINJECTOR_7500MCG, PrescriptionType.ZEPBOUND_AUTOINJECTOR_10000MCG, PrescriptionType.ZEPBOUND_AUTOINJECTOR_12500MCG, PrescriptionType.ZEPBOUND_AUTOINJECTOR_15000MCG],
    howToUse: [
        "Dosage: Follow your doctor’s instructions. Typically, Zepbound is started at a low dose (e.g., 2.5 mg once weekly for 4 weeks) and gradually increased to minimize gastrointestinal side effects.",
        "Administration: Inject subcutaneously in the abdomen, thigh, or upper arm. Rotate injection sites weekly. Do not inject into the same site consecutively.",
        "Missed Dose: If you miss a dose, take it as soon as possible within 4 days (96 hours). If more than 4 days have passed, skip the missed dose and resume your regular schedule."
    ],
    sideEffects: [
        "Common: Nausea, diarrhea, vomiting, abdominal pain, indigestion, injection site reactions (redness, swelling).",
        "Serious: Pancreatitis, gallbladder problems, kidney issues, severe allergic reactions, thyroid tumors."
    ],
    interactions: [
        `Insulin and Sulfonylureas: May increase the risk of hypoglycemia. Monitor blood sugar levels closely.`,
        `Oral Contraceptives: Zepbound may reduce the effectiveness of oral contraceptives. Consider alternative contraceptive methods during treatment.`
    ],
    precautions: [
        "Medical History: Inform your doctor if you have a history of pancreatitis, gallbladder disease, kidney problems, or thyroid tumors.",
        "Pregnancy: Zepbound may harm an unborn baby. Discuss potential risks with your healthcare provider.",
        "Breastfeeding: It is unknown if Zepbound passes into breast milk. Consult your doctor before breastfeeding."
    ],
    overDose: [
        "Symptoms: Overdose may cause severe nausea, vomiting, or hypoglycemia.",
        "Action: If overdose is suspected, seek immediate medical attention or contact a poison control center."
    ],
    storage: [
        "Refrigeration: Store pens in the refrigerator between 36°F to 46°F (2°C to 8°C).",
        "Room Temperature: Pens may be stored at room temperature up to 86°F (30°C) for up to 21 days.",
        "Handling: Do not freeze. Protect from light. Discard if frozen or exposed to temperatures above 86°F (30°C).",
        "Disposal: Do not use past the expiration date. Dispose of unused medication properly"
    ]
  },
  {
    types: [PrescriptionType.ALLOPURINOL_100MG, PrescriptionType.ALLOPURINOL_300MG],
    howToUse: [
        "Dosage: Follow your doctor’s instructions. Typically, allopurinol is started at a low dose (e.g., 100 mg once or twice daily) and gradually increased to minimize gastrointestinal side effects.",
        "Administration: Take allopurinol with meals to reduce stomach upset. Swallow tablets whole; do not crush or chew extended-release tablets.",
        "Missed Dose: If you miss a dose, take it as soon as you remember. If it’s near the time of your next dose, skip the missed dose. Do not double the dose to catch up."
    ],
    sideEffects: [
        "Common: Skin rash, Nausea, Diarrhea, Drowsiness",
        "Serious: Severe skin reactions (e.g., Stevens-Johnson syndrome), Liver issues (e.g., jaundice), Kidney problems, Allergic reactions"
    ],
    interactions: [
        "Azathioprine and Mercaptopurine: Allopurinol can increase the effects of these medications, necessitating dosage adjustments.",
        "Warfarin: May enhance anticoagulant effects; monitor blood clotting parameters.",
        "Diuretics and ACE Inhibitors: Combined use may increase the risk of hypersensitivity reactions."
    ],
    precautions: [
        "Allergies: Inform your doctor of any known allergies, especially to medications.",
        "Pregnancy and Breastfeeding: Consult your healthcare provider before use.",
        "Regular Monitoring: Periodic blood tests may be required to monitor uric acid levels and organ function."
    ],
    overDose: [
        "Symptoms: Nausea, vomiting, dizziness, and reduced kidney function.",
        "Action: Seek immediate medical attention or contact a poison control center."
    ],
    storage: [
        "Temperature: Store at room temperature between 20°C to 25°C (68°F to 77°F).",
        "Protection: Keep in original packaging, away from moisture and light.",
        "Safety: Keep out of reach of children and pets."
    ]
  },
  {
    types: [PrescriptionType.MOUNJARO_12500MCG, PrescriptionType.MOUNJARO_7500MCG, PrescriptionType.MOUNJARO_5000MCG, PrescriptionType.MOUNJARO_2500MCG],
    howToUse: [
        "Dosage: Follow your doctor’s instructions. Typically, Mounjaro is started at a low dose (e.g., 2.5 mg subcutaneously once weekly for 4 weeks) and gradually increased to minimize gastrointestinal side effects.",
        "Administration: Inject subcutaneously in the abdomen, thigh, or upper arm. Rotate injection sites with each dose. Administer once weekly, at any time of day, with or without meals.",
        "Missed Dose: If a dose is missed, administer as soon as possible within 4 days (96 hours) after the missed dose. If more than 4 days have passed, skip the missed dose and administer the next dose on the regularly scheduled day."
    ],
    sideEffects: [
        "Common Side Effects: Nausea, Diarrhea, Decreased appetite, Vomiting, Constipation, Indigestion, Abdominal pain",
        "Serious Side Effects: Pancreatitis, Kidney problems, Severe gastrointestinal issues, Gallbladder problems, Hypoglycemia (especially when used with insulin)"
    ],
    interactions: [
        "Insulin and Insulin Secretagogues: Increased risk of hypoglycemia. Dose adjustments may be necessary.",
        "Oral Medications: Mounjaro delays gastric emptying, which may impact the absorption of concomitantly administered oral medications. Monitor for changes in efficacy of oral drugs"
    ],
    precautions: [
        "Medical History: Inform your healthcare provider if you have a history of pancreatitis, kidney problems, or gallbladder disease.",
        "Pregnancy and Breastfeeding: Mounjaro should be used during pregnancy only if the potential benefit justifies the potential risk to the fetus. It is unknown if tirzepatide is excreted in human milk."
    ],
    overDose: [
        "Medical History: Inform your healthcare provider if you have a history of pancreatitis, kidney problems, or gallbladder disease.",
        "Pregnancy and Breastfeeding: Mounjaro should be used during pregnancy only if the potential benefit justifies the potential risk to the fetus. It is unknown if tirzepatide is excreted in human milk."
    ],
    storage: [
        "Temperature: Store Mounjaro pens in the refrigerator at 2°C to 8°C (36°F to 46°F). If needed, pens can be stored at room temperature up to 30°C (86°F) for up to 21 days.",
        "Protection: Keep the pen in its original carton to protect from light. Do not freeze.",
        "Safety: Keep out of reach of children and pets. Dispose of used pens in a sharps container."
    ]
  },
  {
    types: [PrescriptionType.ALIROCUMAB_75MG, PrescriptionType.ALIROCUMAB_150MG],
    howToUse: [
        "Dosage: Typically, 75 mg subcutaneously every two weeks or 300 mg every four weeks. Dosage may be adjusted based on LDL-C response.",
        "Administration: Inject into the thigh, abdomen, or upper arm. Rotate injection sites with each dose.",
        "Preparation: Allow the prefilled pen or syringe to warm to room temperature for 30 to 40 minutes before injection. Do not heat externally.",
        "Missed Dose: If a dose is missed, administer it as soon as possible within 7 days. If more than 7 days have passed, skip the missed dose and resume the regular schedule."
    ],
    sideEffects: [
        "Common Side Effects: Nasopharyngitis (common cold), Influenza, Urinary tract infections, Diarrhea, Muscle pain or spasms, Sinusitis, Cough, Bruising",
        "Serious Side Effects: Severe allergic reactions (e.g., rash, itching, swelling, difficulty breathing), Liver problems (e.g., yellowing of the skin or eyes, dark urine)"
    ],
    interactions: "No significant drug interactions have been identified. However, always inform your healthcare provider about all medications and supplements you are taking.",
    precautions: [
        "Allergies: Inform your doctor of any known allergies.",
        "Pregnancy and Breastfeeding: The safety of alirocumab during pregnancy and breastfeeding is not well established. Discuss potential risks with your healthcare provider.",
        "Medical Conditions: Inform your doctor if you have liver disease or any other significant health conditions."
    ],
    overDose: "In case of overdose, contact your healthcare provider or seek emergency medical attention. Supportive treatment should be provided as needed.",
    storage: [
        "Refrigeration: Store in the refrigerator at 36°F to 46°F (2°C to 8°C).",
        "Room Temperature: If needed, alirocumab can be kept at room temperature (up to 77°F or 25°C) for up to 30 days. Do not return to the refrigerator after it has been stored at room temperature.",
        "Protection: Keep in the original carton to protect from light.",
        "Disposal: Dispose of used pens or syringes in a puncture-resistant sharps container."
    ]
  },
  {
    types: [PrescriptionType.EVOLOCUMAB_140MG],
    howToUse: [
        "Doage: Follow your doctor’s instructions. For adults with cardiovascular disease or primary hyperlipidemia, the usual dose is 140 mg subcutaneously every 2 weeks or 420 mg once monthly. For patients with HoFH: 420 mg subcutaneously once monthly; may increase to every 2 weeks if a clinically meaningful response is not achieved.",
        "Administration: Inject subcutaneously into the abdomen, thigh, or upper arm. Rotate injection sites with each dose.",
        "Missed Dose: If a dose is missed, administer it as soon as possible within 7 days. If more than 7 days have passed, skip the missed dose and resume the regular schedule."
    ],
    sideEffects: [
        "Common Side Effects: Nasopharyngitis (common cold symptoms), Upper respiratory tract infection, Influenza, Back pain, Injection site reactions (redness, pain, bruising), Headache, Myalgia (muscle pain), Dizziness, Hypertension (high blood pressure), Diarrhea, Fatigue",
        "Serious Side Effects: Severe allergic reactions (e.g., angioedema), Elevated blood sugar levels (hyperglycemia)"
    ],
    interactions: "Evolocumab has a low potential for drug interactions. However, always inform your healthcare provider about all medications and supplements you are taking.",
    precautions: [
        "Allergies: Inform your doctor of any known allergies, especially to latex.",
        "Pregnancy and Breastfeeding: There is limited data on the use of evolocumab during pregnancy and breastfeeding. Discuss potential risks and benefits with your healthcare provider."
    ],
    overDose: "In case of overdose, seek immediate medical attention or contact a poison control center at 1-800-222-1222.",
    storage: [
        "Refrigeration: Store in the refrigerator at 36°F to 46°F (2°C to 8°C).",
        "Room Temperature: If needed, evolocumab can be kept at room temperature (up to 77°F or 25°C) in the original carton for up to 30 days.",
        "Protection: Keep in the original carton to protect from light.",
        "Disposal: Dispose of used pens or syringes in a puncture-resistant sharps container."
    ]
  },
  {
    types: [PrescriptionType.METOPROLOL_TARTRATE_50MG_CCTA],
    howToUse: [
        "Dosage: Take metoprolol exactly as prescribed by your doctor. The dosage varies based on the condition being treated.",
        "Administration: Swallow the tablet whole with water, preferably with or immediately after a meal to enhance absorption.",
        "Missed Dose: If you miss a dose, take it as soon as you remember. If it’s close to your next scheduled dose, skip the missed one. Do not double the dose to catch up."
    ],
    sideEffects: [
        "Common Side Effects: Fatigue, Dizziness, Shortness of breath, Cold hands and feet, Depression, Nausea",
        "Serious Side Effects: Very slow heart rate, Worsening heart failure symptoms (e.g., swelling of ankles/feet, severe fatigue), Sudden weight gain, Fainting, Blue fingers/toes, Unusual mood changes"
    ],
    interactions: [
        "Other Blood Pressure Medications: Combining with other antihypertensives can enhance blood pressure-lowering effects.",
        "Antidepressants: Certain antidepressants can increase metoprolol levels in the blood.",
        "Diabetes Medications: Metoprolol may mask symptoms of low blood sugar. Monitor blood sugar levels closely."
    ],
    precautions: [
        "Medical Conditions: Inform your doctor if you have asthma, diabetes, liver disease, or any other significant health issues.",
        "Pregnancy and Breastfeeding: Discuss with your doctor if you are pregnant, planning to become pregnant, or breastfeeding.",
        "Alcohol: Limit alcohol consumption, as it can enhance certain side effects of metoprolol."
    ],
    overDose: [
        "In case of overdose, symptoms may include: Severe dizziness, Fainting, Very slow heart rate, Difficulty breathing",
        "If you suspect an overdose, seek immediate medical attention or call a poison control center."
    ],
    storage: [
        "Temperature: Store at room temperature, away from moisture and heat.",
        "Safety: Keep out of reach of children and pets.",
        "Disposal: Do not flush medications down the toilet. Dispose of them properly, following local guidelines or through a take-back program."
    ]
  },
  {
    types: [PrescriptionType.LEQVIO_284MG],
    howToUse: [
        "Dosage: Leqvio is typically administered as a 284 mg subcutaneous injection. The dosing schedule is as follows: Initial dose, Second dose at 3 months, Subsequent doses every 6 months.",
        "Administration: Injections should be given by a healthcare professional into the abdomen, upper arm, or thigh. Avoid injecting into areas with active skin disease or injury.",
        "Missed Dose: If a dose is missed by less than 3 months, administer as soon as possible and continue with the original schedule. If more than 3 months have passed, restart the dosing schedule: administer a dose, then another at 3 months, followed by doses every 6 months.",
    ],
    sideEffects: [
        "Common Side Effects (≥3% of patients): Injection site reactions (pain, redness, rash), Joint pain (arthralgia), Bronchitis",
        "Less Common Side Effects: Urinary tract infections, Diarrhea, Pain in limbs, Shortness of breath",
        "Serious Side Effects: Severe allergic reactions (e.g., angioedema), Elevated blood sugar levels (hyperglycemia)"
    ],
    interactions: "Leqvio has a low potential for drug interactions. It is not metabolized by cytochrome P450 enzymes and does not significantly interact with other medications.",
    precautions: [
        "Medical Conditions: Inform your healthcare provider if you have liver or kidney disease.",
        "Pregnancy and Breastfeeding: Discuss potential risks and benefits with your healthcare provider."
    ],
    overDose: "In the event of an overdose, contact your healthcare provider or seek emergency medical attention. Supportive treatment should be provided as needed.",
    storage: [
        "Temperature: Store at room temperature between 20°C to 25°C (68°F to 77°F). Excursions permitted between 15°C to 30°C (59°F to 86°F).",
        "Appearance: Leqvio is a clear, colorless to pale yellow solution. Do not use if the solution is discolored or contains particles.",
        "Disposal: Dispose of used syringes in a puncture-resistant sharps container."
    ]
  },
  {
    types: [PrescriptionType.LODOCO_05MG],
    howToUse: [
        "Dosage: Take as directed by your doctor. Lodoco is typically administered as a 0.5 mg tablet orally once daily.",
        "Administration: Lodoco can be taken with or without food.",
        "Missed Dose: If you miss a dose, take it as soon as you remember. If it’s near the time of your next dose, skip the missed dose. Do not double up to make up for a missed dose."
    ],
    sideEffects:  [
        "Common Side Effects: Diarrhea, Nausea, Abdominal pain, Muscle pain",
        "Serious Side Effects: Blood Disorders: Symptoms include fever, chills, sore throat, unusual bleeding or bruising. Muscle Damage: Symptoms include muscle weakness, pain, or dark-colored urine. Neuropathy: Symptoms include numbness or tingling in the hands or feet."
    ],
    interactions: [
        "Lodoco interacts with numerous medications. Notably, combining it with strong CYP3A4 or P-gp inhibitors can significantly increase colchicine levels, leading to toxicity.",
        "Additionally, concurrent use with statins or fibrates may increase the risk of muscle-related side effects.",
        "Avoid grapefruit or grapefruit juice, as they can increase colchicine concentrations."
    ],
    precautions: [
        "Pregnancy and Breastfeeding: The safety of Lodoco during pregnancy and lactation has not been established. Consult your healthcare provider before use.",
        "Fertility: Lodoco may rarely and transiently impair male fertility.",
        "Elderly Patients: Use with caution in older adults, as they may be more susceptible to side effects."
    ],
    overDose: "In case of overdose, symptoms may include severe gastrointestinal distress, muscle weakness, and multi-organ failure. Seek immediate medical attention or contact a poison control center.",
    storage: [
        "Temperature: Store at room temperature, away from moisture and heat.",
        "Safety: Keep out of reach of children and pets.",
        "Disposal: Do not flush medications down the toilet. Dispose of them properly, following local guidelines or through a take-back program."
    ]
  }

];